import {useReadOrderStatus} from "../../hooks/useReadOrderStatus";
import {dashboardOrderStatusInit} from "../../state";
import {DashboardOrderStatusType} from "../../interface";
import useGoToNavigation from "../../../../../../util/useGotoNavigation"; // 내부수정: 테이블 클릭 시 메뉴 이동

export const OrderStatus = () => {
    const {data: orderStatusApiData} = useReadOrderStatus()
    const orderStatus: DashboardOrderStatusType = orderStatusApiData ?? dashboardOrderStatusInit
    const {goToNavigation} = useGoToNavigation()  // 내부수정: 메뉴 이동
    const clickTable1 = () => goToNavigation("order/orderRequest/list", {}, false)
    const clickTable2 = () => goToNavigation("order/orders/list", {}, false)
    const clickTable3 = () => goToNavigation("order/deadline/list", {}, false)
    const clickTable4 = () => goToNavigation("support/rma/list?pageNo=1", {}, false)

    return (
        <div className="content_wrap h-221px">
            <div className="fiter_top">
                <h3 className="filter_heading">금주 수주현황(총 <span>{orderStatus.totalCount}</span> 건)</h3>
                <div className="filter_toolbar"></div>
            </div>
            {/* 내부수정: 메뉴 이동 <table className="table table-bordered my_table table_detail mb-0" > */}
            <table className="table table-bordered my_table table_detail mb-0 clickable">
                <tbody>
                <tr className="tr-50px">
                    <th style={{width: "24.6%"}} onClick={clickTable1}>수주</th>
                    <td style={{width: "25.4%"}} className="text-end">{orderStatus.orderCount}건</td>
                    <th style={{width: "24.6%"}} onClick={clickTable2}>이관</th>
                    <td className="text-end">{orderStatus.transferCount}건</td>
                </tr>
                <tr className="tr-50px">
                    <th onClick={clickTable2}>출하요청</th>
                    <td className="text-end">{orderStatus.shipmentRequestCount}건</td>
                    <th onClick={clickTable3}>마감</th>
                    <td className="text-end">{orderStatus.completeCount}건</td>
                </tr>
                <tr className="tr-50px">
                    <th onClick={clickTable2}>출하</th>
                    <td className="text-end">{orderStatus.shipmentCount}건</td>
                    <th onClick={clickTable4}>RMA</th>
                    <td className="text-end">{orderStatus.rmaCount}건</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}